import React, { Children, useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import {
  KeyboardArrowDownIcon,
  DeleteForeverIcon,
  EditIcon,
} from "src/Pages/components/Icons/Icons";

import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";

import { useHttpTableLeads } from "./Hooks/useHttpTableLeads";
import { THeadLeads } from "./THead";
import { ModalLeads } from "../Form";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { useContextLeads } from "src/Contexts/Leads/LeadsContext";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import {
  OBjLeadsInterestLevel,
  objLeadsSourceCollection,
  objLeadsStatus,
} from "src/Pages/components/ObjTransform";
import { alpha, Box, Menu, MenuItem } from "@mui/material";
import { IInterestLevelLeads, IListLeads } from "src/Contexts/Leads/LeadsTypes";
import { useResetInputs } from "src/Contexts";
import { UseSetGetLeadsById } from "./Hooks/UseGetByIdContratos";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { RotatingCachedIcon } from "src/Pages/components/Icons/RotatingCachedIcon";
import { useUpdateInterestLevel } from "./Hooks/useUpdateInterestLevel";
import { useGetSheetLeads } from "./Hooks/useGetSheetLeads";
import { FilterSidebar } from "../FilterSidebar/FilterSidebar";

export const TableLeads = () => {
  const { handleSetDateLeadsGetById } = UseSetGetLeadsById();
  const { resetInputs } = useResetInputs();
  const { listLeads } = useContextLeads();
  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    loadingTable,
    nameSearch,
    setAttTable,
    attTable,
    setId,
  } = useConfigPageContext();
  const { handleGet } = useHttpTableLeads();
  const { handleUpdateInterestLevel } = useUpdateInterestLevel();

  const [openModalLeads, setOpenModalLeads] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [idLead, setIdLead] = useState<string | null>(null);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorEl(event.currentTarget);
    setIdLead(id);
  };

  const updateInterestLevel = (level: IInterestLevelLeads) => {
    if (!idLead) return;
    handleUpdateInterestLevel(idLead, level);
    setAnchorEl(null);
    setIdLead(null);
  };

  const handleGetIdToEdit = (id: string, data: IListLeads) => {
    resetInputs();
    setId(id);
    setOpenModalLeads(true);
    handleSetDateLeadsGetById(data);
  };

  useEffect(() => {
    handleGet();
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/leads" });

  return (
    <TableCore
      heightTable="420px"
      Modals={
        <>
          <ModalLeads
            openModal={openModalLeads}
            setOpenModal={setOpenModalLeads}
          />
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
        </>
      }
      THead={<THeadLeads />}
      qtdList={listLeads.length}
      setNameSearch={setNameSearch}
      filter={<FilterSidebar />}
      cardAdd={{
        title: "Leads",
        buttons: [
          <RotatingCachedIcon
            onClick={() => setAttTable((item) => !item)}
            isLoading={loadingTable}
            tooltipTitle="Recarregar a página"
          />,
          <ButtonCore
            size="small"
            startIcon={<SaveAltIcon />}
            title="Exportar"
            variant="outlined"
            onClick={() => useGetSheetLeads()}
          />,
          <ButtonCore
            size="small"
            startIcon={<AddIcon />}
            title="Criar Lead"
            onClick={() => setOpenModalLeads(true)}
          />,
        ],
      }}
    >
      {Children.toArray(
        listLeads.map((item) => {
          return (
            <TableRowCore id={String(item.id)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        onClick: () => {
                          handleGetIdToEdit(String(item.id), item);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        onClick: () => {
                          setIdModalDelete(item.id);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore
                values={item.name}
                avatar={item.name}
                subTitle={item.email}
              />

              <TdCore
                textAlign="left"
                values={cpfOurCnpj({ text: item?.whats || "", type: "phone" })}
                subTitle={cpfOurCnpj({
                  text: item?.telefone1 || "",
                  type: "phone",
                })}
              />

              <TdCore
                textAlign="center"
                values={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonCore
                      title={OBjLeadsInterestLevel[
                        item.interestLevel
                      ].title.toUpperCase()}
                      variant="outlined"
                      onClick={(e) => handleClick(e, item.id)}
                      size="small"
                      endIcon={<KeyboardArrowDownIcon />}
                      sx={{
                        boxShadow: 0,
                        color: alpha(
                          OBjLeadsInterestLevel[item.interestLevel].color,
                          0.8
                        ),
                        borderColor: alpha(
                          OBjLeadsInterestLevel[item.interestLevel].color,
                          0.8
                        ),
                        "&:hover &:focus": {
                          borderColor: alpha(
                            OBjLeadsInterestLevel[item.interestLevel].color,
                            0.8
                          ),
                        },
                        "&:hover": {
                          borderColor: alpha(
                            OBjLeadsInterestLevel[item.interestLevel].color,
                            0.8
                          ),
                        },
                        width: "110px",
                      }}
                    />

                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={() => setAnchorEl(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      sx={{
                        "& .MuiPaper-root": {
                          borderRadius: "12px",
                          minWidth: "110px",
                          boxShadow:
                            "0px 0px 4px 0px rgba(131, 131, 131, 0.13)",
                        },
                        "& .MuiList-root": {
                          paddingTop: "4px",
                          paddingBottom: "4px",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => updateInterestLevel("HIGH")}
                        sx={{
                          "&:hover": {
                            background: alpha(
                              OBjLeadsInterestLevel.HIGH.color,
                              0.3
                            ),
                          },
                        }}
                      >
                        ALTO
                      </MenuItem>
                      <MenuItem
                        onClick={() => updateInterestLevel("MEDIUM")}
                        sx={{
                          "&:hover": {
                            background: alpha(
                              OBjLeadsInterestLevel.MEDIUM.color,
                              0.3
                            ),
                          },
                        }}
                      >
                        MÉDIO
                      </MenuItem>
                      <MenuItem
                        onClick={() => updateInterestLevel("LOW")}
                        sx={{
                          "&:hover": {
                            background: alpha(
                              OBjLeadsInterestLevel.LOW.color,
                              0.3
                            ),
                          },
                        }}
                      >
                        BAIXO
                      </MenuItem>
                    </Menu>
                  </Box>
                }
              />
              <TdCore textAlign="left" values={objLeadsStatus[item.status]} />
              <TdCore
                textAlign="left"
                values={objLeadsSourceCollection[item.sourceCollection]}
              />

              <TdCore textAlign="left" values={FormatDateBR(item.captureAt)} />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
